module.exports = __webpack_public_path__ + "static/img/jianjie.954d983.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jianjie.png
// module id = UT1C
// module chunks = 1